import React from 'react'

const CashPaymentForm = ({
  handleSubmit,
  value,
  changeValue,
  setChangeValue,
  closeCashModal,
  loading = false,
}) => {
  const numericValue = Number(value || 0)
  const numericChangeValue = Number(changeValue || 0)
  const change =
    numericChangeValue > numericValue
      ? (Math.round((numericChangeValue - numericValue) * 100) / 100).toFixed(2)
      : '0.00'

  return (
    <>
      <div className='mt-1 text-center h5 shadow-sm p-2 bg-white rounded'>
        Cash Payment
      </div>

      <form className='mt-3 h5' onSubmit={handleSubmit}>
        <div className='form-group row'>
          <label className='col-sm-4 col-form-label'>Final Total</label>
          <div className='col-sm-8'>
            <input
              type='text'
              readOnly
              className='form-control-plaintext'
              value={(Math.round(numericValue * 100) / 100).toFixed(2)}
            />
          </div>
        </div>

        <div className='form-group row'>
          <label className='col-sm-4 col-form-label'>Change</label>
          <div className='col-sm-8'>
            <input
              type='text'
              readOnly
              className='form-control-plaintext'
              value={change}
            />
          </div>
        </div>

        <div className='form-group row'>
          <label className='col-sm-4 col-form-label'>Amount</label>
          <div className='col-sm-8'>
            <input
              type='number'
              className='form-control mt-2 fs-5'
              value={changeValue}
              onChange={(e) => setChangeValue(e.target.value)}
              autoFocus
            />
          </div>
        </div>
        <div className='text-end mt-4'>
          <button
            type='submit'
            className='btn btn-outline-success'
            disabled={loading}
          >
            {loading ? 'Processing...' : 'Submit'}
          </button>
          <button
            type='button'
            className='btn btn-outline-secondary ms-5'
            onClick={closeCashModal}
            disabled={loading}
          >
            Close
          </button>
        </div>
      </form>
    </>
  )
}

export default CashPaymentForm
